import { useLocalStorage } from "react-use";

const REMEMBER_ME_KEY = "remember-me-default";

export const useRememberMe = () =>
  useLocalStorage<boolean>(REMEMBER_ME_KEY, false);
